import AdminResourceList from  "../../components/Programming/AdminResourceList"


const AdminResourcesList = () => {
     return( 
          <AdminResourceList />
     )
}

export default AdminResourcesList